module.exports = __webpack_public_path__ + "img/Icon - EBIS.c62b336d.png";